export default {"src":"/_next/static/media/top-l.97e19a52.svg","height":299,"width":75,"blurWidth":0,"blurHeight":0};